export type StockCategory = "technology" | "financials" | "consumer" | "healthcare" | "energy" | "industrial" | "etf" | "other";

export type StockCatalogItem = {
  symbol: string;
  name: string;
  category: StockCategory;
  featured?: boolean;
};

export const stockCatalog: StockCatalogItem[] = [
  { symbol: "AAPL", name: "Apple", category: "technology", featured: true },
  { symbol: "MSFT", name: "Microsoft", category: "technology", featured: true },
  { symbol: "NVDA", name: "NVIDIA", category: "technology", featured: true },
  { symbol: "AMZN", name: "Amazon", category: "consumer", featured: true },
  { symbol: "GOOGL", name: "Alphabet", category: "technology", featured: true },
  { symbol: "META", name: "Meta Platforms", category: "technology", featured: true },
  { symbol: "AVGO", name: "Broadcom", category: "technology" },
  { symbol: "ORCL", name: "Oracle", category: "technology" },
  { symbol: "TSLA", name: "Tesla", category: "consumer" },
  { symbol: "UBER", name: "Uber Technologies", category: "consumer" },
  { symbol: "QSR", name: "Restaurant Brands International", category: "consumer" },
  { symbol: "SOUN", name: "SoundHound AI", category: "technology" },
  { symbol: "NFLX", name: "Netflix", category: "consumer" },
  { symbol: "JPM", name: "JPMorgan Chase", category: "financials", featured: true },
  { symbol: "V", name: "Visa", category: "financials" },
  { symbol: "MA", name: "Mastercard", category: "financials" },
  { symbol: "BRK.B", name: "Berkshire Hathaway", category: "financials" },
  { symbol: "BAC", name: "Bank of America", category: "financials" },
  { symbol: "GS", name: "Goldman Sachs", category: "financials" },
  { symbol: "BN", name: "Brookfield Corporation", category: "financials" },
  { symbol: "HHH", name: "Howard Hughes Holdings", category: "financials" },
  { symbol: "KO", name: "Coca-Cola", category: "consumer" },
  { symbol: "PEP", name: "PepsiCo", category: "consumer" },
  { symbol: "COST", name: "Costco", category: "consumer" },
  { symbol: "WMT", name: "Walmart", category: "consumer" },
  { symbol: "MCD", name: "McDonald's", category: "consumer" },
  { symbol: "PG", name: "Procter & Gamble", category: "consumer" },
  { symbol: "LLY", name: "Eli Lilly", category: "healthcare" },
  { symbol: "UNH", name: "UnitedHealth Group", category: "healthcare" },
  { symbol: "JNJ", name: "Johnson & Johnson", category: "healthcare" },
  { symbol: "MRK", name: "Merck", category: "healthcare" },
  { symbol: "XOM", name: "Exxon Mobil", category: "energy" },
  { symbol: "CVX", name: "Chevron", category: "energy" },
  { symbol: "LMT", name: "Lockheed Martin", category: "industrial" },
  { symbol: "CAT", name: "Caterpillar", category: "industrial" },
  { symbol: "CNI", name: "Canadian National Railway", category: "industrial" },
  { symbol: "ECL", name: "Ecolab", category: "industrial" },
  { symbol: "WM", name: "Waste Management", category: "industrial" },
  { symbol: "SPY", name: "SPDR S&P 500 ETF", category: "etf", featured: true },
  { symbol: "IVV", name: "iShares Core S&P 500 ETF", category: "etf" },
  { symbol: "QQQ", name: "Invesco QQQ ETF", category: "etf", featured: true },
  { symbol: "DIA", name: "SPDR Dow Jones ETF", category: "etf" },
  { symbol: "IWM", name: "iShares Russell 2000 ETF", category: "etf" },
  { symbol: "VTI", name: "Vanguard Total Stock Market ETF", category: "etf" },
];

export const stockCategoryLabels: Record<StockCategory, string> = {
  technology: "Technology",
  financials: "Financials",
  consumer: "Consumer",
  healthcare: "Healthcare",
  energy: "Energy",
  industrial: "Industrial",
  etf: "ETFs",
  other: "Other",
};

export function normalizeStockCategory(value: unknown): StockCategory {
  const category = String(value ?? "").trim().toLowerCase();
  if (category.includes("etf") || category.includes("fund")) return "etf";
  if (category.includes("tech") || category.includes("semiconductor") || category.includes("software")) return "technology";
  if (category.includes("financial") || category.includes("bank") || category.includes("insurance")) return "financials";
  if (category.includes("consumer") || category.includes("retail") || category.includes("restaurant")) return "consumer";
  if (category.includes("health") || category.includes("pharma") || category.includes("biotech")) return "healthcare";
  if (category.includes("energy") || category.includes("oil") || category.includes("gas")) return "energy";
  if (category.includes("industrial") || category.includes("defense") || category.includes("rail")) return "industrial";
  return "other";
}

export function findStock(symbol: string) {
  return stockCatalog.find((stock) => stock.symbol === symbol.toUpperCase());
}
